import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { forkJoin, Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import {
  DEFAULT_TIMEOUT,
  HttpRequestMethods,
  IDP_APPS
} from '../../constants/utils';
import { SITE_WIDE_VACATION_SEARCH } from '../../constants/vacation/vacation.constants';
import {
  SearchOrgDestRequest,
  SearchOrgDestResponse
} from '../../models/vacation/vacation-contents.interfaces';
import { ApiBuilder, AppConfigService, handleError } from '../utils';

@Injectable({
  providedIn: 'root'
})
export class VacationContentService {
  http = inject(HttpClient);
  appConfigService = inject(AppConfigService);
  vacationOrgDest$!: Observable<[SearchOrgDestResponse, SearchOrgDestResponse]>;

  _errorHandler = handleError.bind(this);

  getVacationOriginAndDestination(
    _dataOrigin: SearchOrgDestRequest,
    _dateDestination: SearchOrgDestRequest
  ): Observable<[SearchOrgDestResponse, SearchOrgDestResponse]> {
    if (this.vacationOrgDest$) {
      return this.vacationOrgDest$;
    } else {
      this.vacationOrgDest$ = forkJoin([
        this.searchOriginDest(_dataOrigin),
        this.searchOriginDest(_dateDestination)
      ]).pipe(shareReplay());
      return this.vacationOrgDest$;
    }
  }

  private searchOriginDest = (
    _data: SearchOrgDestRequest
  ): Observable<SearchOrgDestResponse> =>
    new ApiBuilder<SearchOrgDestRequest, SearchOrgDestResponse>(
      this.http,
      this.appConfigService
    )
      .app(IDP_APPS.HEADER)
      .endpointKey('BFF_SEARCH_DEST')
      .method(HttpRequestMethods.POST)
      .payload(_data)
      .errorHandler(this._errorHandler)
      .timeOut(DEFAULT_TIMEOUT)
      .library(SITE_WIDE_VACATION_SEARCH)
      .create();
}
